<template>
  <span style="display:inline-block;border-right:1px solid #eee"></span>
</template>
<script>
  export default{
    name: "v-split"
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// VSplit.vue?cf0654c4